export default __webpack_public_path__ + "static/media/rings.f9c471fd.svg";